module.exports = __webpack_public_path__ + "static/media/InternalMedicineImage2@2x.cc6114a8.png";